import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

const REF_KEY = "dealhub.ref";
const REF_DEAL_KEY = "dealhub.ref_deal";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";

    if (!sessionId) {
      toast.error("Missing Google session. Please try again.");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const referrerId = localStorage.getItem(REF_KEY) || undefined;
        const referrerDealId = localStorage.getItem(REF_DEAL_KEY) || undefined;
        const { data } = await api.post("/auth/google-callback", {
          session_id: sessionId,
          referrer_id: referrerId,
          referrer_deal_id: referrerDealId,
        });
        localStorage.setItem("dh_token", data.token);
        if (data.referred) {
          try {
            localStorage.removeItem(REF_KEY);
            localStorage.removeItem(REF_DEAL_KEY);
          } catch (storageErr) {
            console.warn("Could not clear ref keys after credit", storageErr);
          }
        }
        // Clear the fragment before we refresh AuthContext so subsequent renders don't re-trigger
        try {
          window.history.replaceState(null, "", "/");
        } catch (historyErr) {
          console.warn("history.replaceState failed", historyErr);
        }
        await refresh();
        if (data.is_new) {
          toast.success(`Welcome to DealHub, ${data.name}!`);
        } else {
          toast.success(`Welcome back, ${data.name}!`);
        }
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="auth-callback-page">
      <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E63946] mb-3">Signing you in</div>
      <h1 className="font-serif font-black text-3xl md:text-4xl tracking-tighter mb-2">One moment…</h1>
      <p className="text-black/60">Confirming your Google session with DealHub.</p>
    </div>
  );
}
